import { RangeSelectInfo } from 'components/molecules/range-select-list'

import { useTranslate } from 'hooks/translation/use-translation'

const useProductionLeadTimeFilter = () => {
  const { t } = useTranslate('strapi-search-[...term]')
  const getProductionLeadTimeRangeSelectInfos = (rangeMin: number, rangeMax: number): RangeSelectInfo[] => {
    if (rangeMin > rangeMax) throw new Error('rangeMin must be less than or equal to rangeMax')

    const rangeInfos = [
      {
        label: t('Filters.Filters_range_select_days_or_less', { numDays: 3 }),
        value: [rangeMin, 3],
      },
      {
        label: t('Filters.Filters_range_select_days_or_less', { numDays: 6 }),
        value: [rangeMin, 6],
      },
      {
        label: t('Filters.Filters_range_select_days_or_less', { numDays: 9 }),
        value: [rangeMin, 9],
      },
      {
        label: t('Filters.Filters_range_select_days_or_less', { numDays: 14 }),
        value: [rangeMin, 14],
      },
      {
        label: t('Filters.Filters_range_select_days_or_less', { numDays: 30 }),
        value: [rangeMin, 30],
      },
      {
        label: t('Filters.Filters_range_select_days_or_more', { numDays: 30 }),
        value: [30, rangeMax],
      },
    ]

    return rangeInfos.filter((rangeInfo, index) => {
      const isRangeValid = rangeInfo.value[0] <= rangeInfo.value[1]
      const isPreviousRangeCovered = index !== 0 ? rangeInfos[index - 1].value[1] < rangeMax : true
      return isRangeValid && isPreviousRangeCovered
    })
  }

  return { getProductionLeadTimeRangeSelectInfos }
}

export default useProductionLeadTimeFilter
